import { useState, useEffect, useContext, useRef, useCallback } from 'react';

import { Popover, Dropdown, Image, message } from 'antd';
import Cookies from 'js-cookie';
import { debounce } from 'lodash-es';

import BomUpload from './components/bomUpload';
import {
  MobileIntroPop,
  MemberCenterPop,
  ServiceCenterPop,
  GroupSitesPop,
  PlusInfoPop,
  ShopCarPop,
  SearchHistoryListPop,
  SearchListPop,
  CatalogsPop,
  MerchantServicePop,
  MroCatalogsPop,
  SeoCatalogsContent,
} from './components/popBus.js';
import { getAssociationalWordList, getCartDataApi, getPlusInfo, getMroResourceList, checkKeyWord } from './header-http';

import SvgIcon from '@lcsc-ui/components/SvgIcon';
import IndexTopBanner from '@lcsc-ui/layouts/baseHeader/components/IndexTopBanner';
import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import useUserStore from '@lcsc-ui/store/user';
import { buriedPoint, getBuriedPointCP, getNavPoint, headBuriedPoint } from '@lcsc-ui/utils/buriedPoint';
import Utils from '@lcsc-ui/utils/Utils';

export function Topbar({ className }) {
  const { isMro, resourceData, onlySScreen } = useContext(LayoutContext);
  const containerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [plusInfo, setPlusInfo] = useState({});
  const [_userInfo, _setUserInfo] = useState();

  const { userInfo } = useUserStore();

  async function initPlusInfo() {
    const { code, result } = await getPlusInfo();
    if (code === 200 && result) {
      setPlusInfo(result);
    }
  }

  useEffect(() => {
    initPlusInfo();
  }, []);

  useEffect(() => {
    _setUserInfo(userInfo);
    if (userInfo?.customerLogin === 1) {
      initPlusInfo();
    }
  }, [userInfo]);

  useEffect(() => {
    if (Utils.getUrlParam('jlcGroup_source')) {
      Cookies.set('jlcGroup_source', Utils.getUrlParam('jlcGroup_source'), {
        domain: '.szlcsc.com',
        expires: 365,
        path: '/',
      });
    } else if (Utils.getUrlParam('c')) {
      Cookies.set('jlcGroup_source', 'lc_' + Utils.getUrlParam('c'), {
        domain: '.szlcsc.com',
        expires: 365,
        path: '/',
      });
    }
  }, []);

  // 跳登录和注册
  async function gotoLogin(e, type) {
    buriedPoint({
      cp: 'top_header',
      ty: 'click',
      op: type,
      data: {
        hf: type === 'LOGIN' ? '/login.html' : '/home/register.html',
      },
    });
  }

  function onOpenChange(value) {
    if (value && _userInfo?.customerLogin === 1) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }

  function handleMobileIntroPopShow(e, href) {
    if (e) {
      headBuriedPoint('app', href, 'enter');
    }
  }

  let userInfoDom;
  if (_userInfo) {
    if (_userInfo?.customerLogin === 1) {
      userInfoDom = (
        <div className="mr-[5px] flex items-center">
          <span>您好，</span>
          <a
            target="_blank"
            href={`${resourceData?.projectConfigVO?.lcscMemberUrl}/member/center.html`}
            rel="nofollow"
            className="text-lcBlue"
            onClick={() => {
              headBuriedPoint('user_name', `${resourceData?.projectConfigVO?.lcscMemberUrl}/member/center.html`);
            }}
          >
            {_userInfo?.customerCode}
          </a>
          <span
            className={`ml-[6px] inline-block h-[17px] w-[38px] rounded-[2px] text-center text-[12px] leading-[17px]
        ${plusInfo?.isPlusMember ? 'bg-[#2e3244] text-[#f1d997]' : 'bg-[#b1b1b2] text-[white]'}`}
          >
            PLUS
          </span>
          <SvgIcon app="common" iconName="down-outlined" className="ml-[6px] h-[8px] w-[8px]" />
        </div>
      );
    } else {
      userInfoDom = (
        <>
          <span>您好，请</span>
          <a
            id="login"
            href="/login.html"
            rel="nofollow"
            className="text-lcBlue mr-[5px]"
            onClick={(e) => {
              gotoLogin(e, 'LOGIN');
            }}
            data-spm="dl"
          >
            登录
          </a>
          <a
            id="register"
            href="/home/register.html"
            rel="nofollow"
            className="hover:text-lcBlue mr-[16px]"
            onClick={(e) => {
              gotoLogin(e, 'REGISTER');
            }}
            data-spm="zc"
          >
            免费注册
          </a>
        </>
      );
    }
  }

  const topbarClassNames = Utils.addBigScreenClassName(
    `m-auto flex h-[36px] w-[1200px] relative ${isMro ? 'justify-end' : 'justify-between'} text-[12px]`,
    '_lg:w-[1552px]',
    onlySScreen
  );

  return (
    <section
      data-spm="hd"
      className={`border-soild border-b-[1px] border-[#E6E7EC] bg-[#F5F5F5] text-[#6C6C6C] ${className || ''}`}
    >
      <div id="top-bar" className={topbarClassNames}>
        {isMro && (
          <a
            className="hover:text-lcBlue absolute left-[0] top-[9px] mr-[80px] flex cursor-pointer items-center"
            href={`${resourceData?.projectConfigVO?.lcscWwwUrl}`}
            rel="nofollow"
            target="_blank"
          >
            <SvgIcon app="common" iconName="back" className="h-[16px] w-[16px]" />
            <span className="text-lcBlue ml-[8px]">返回立创商城</span>
          </a>
        )}
        <div id="tob-bar-left" ref={containerRef} className="relative flex items-center">
          <Popover
            overlayClassName="lcsc-popover-wrapper"
            content={<PlusInfoPop plusInfo={plusInfo} />}
            overlayInnerStyle={{ padding: 0 }}
            open={isOpen}
            onOpenChange={onOpenChange}
          >
            <div className="mr-[16px] flex cursor-pointer">{userInfoDom}</div>
          </Popover>
          <Popover
            overlayStyle={{
              width: '199px',
              height: '124px',
            }}
            content={<MemberCenterPop headBuriedPoint={headBuriedPoint} />}
            getPopupContainer={() => containerRef.current}
          >
            <a
              target="_blank"
              href={`${resourceData?.projectConfigVO?.lcscMemberUrl}/member/workbench.html`}
              aria-label="我的工作台"
              rel="nofollow"
              data-spm="hy"
              className="bg-lcBlue relative mr-[12px] flex items-center rounded-[2px] px-[3px] text-[#fff] hover:text-[#fff]"
              onClick={() => {
                headBuriedPoint('my_member', `${resourceData?.projectConfigVO?.lcscMemberUrl}/member/workbench.html`);
              }}
            >
              <span>我的工作台</span>
              <SvgIcon app="common" iconName="down-outlined" className="ml-[4px] h-[8px] w-[8px]" />
            </a>
          </Popover>
          <Popover
            content={<MobileIntroPop />}
            onOpenChange={(e) => handleMobileIntroPopShow(e, `${resourceData?.projectConfigVO?.lcscWwwUrl}/app.html`)}
          >
            <a
              className="hover:text-lcBlue mr-[16px] flex cursor-pointer items-center"
              rel="nofollow"
              target="_blank"
              href={`${resourceData?.projectConfigVO?.lcscWwwUrl}/app.html`}
            >
              <span>手机立创</span>
              <SvgIcon app="common" iconName="down-outlined" className="ml-[6px] h-[8px] w-[8px]" />
            </a>
          </Popover>
          <a
            className="hover:text-lcBlue mr-[16px]"
            href={`${resourceData?.projectConfigVO?.lcscMemberUrl}/member/ms.html`}
            rel="nofollow"
            onClick={() => headBuriedPoint('message', `${resourceData?.projectConfigVO?.lcscMemberUrl}/member/ms.html`)}
            data-spm="xx"
            target="_blank"
          >
            消息(
            <span className="text-lcBlue">{_userInfo?.messageNum > 99 ? '99+' : _userInfo?.messageNum || 0}</span>)
          </a>
        </div>
        <div id="tob-bar-right" className={`flex w-[480px] items-center justify-between`}>
          <a
            data-spm="dd"
            href={`${resourceData?.projectConfigVO?.lcscMemberUrl}/member/order/list.html`}
            className="hover:text-lcBlue"
            rel="nofollow"
            onClick={() => {
              headBuriedPoint('member_order', `${resourceData?.projectConfigVO?.lcscMemberUrl}/member/order/list.html`);
            }}
          >
            我的订单
          </a>
          <a
            href={`${resourceData?.projectConfigVO?.lcscCartUrl}/cart/display.html`}
            className="hover:text-lcBlue"
            rel="nofollow"
            data-spm="c1"
            target="_blank"
          >
            购物车(
            <span className="text-lcBlue">{_userInfo?.cartNum > 99 ? '99+' : _userInfo?.cartNum || '0'}</span>)
          </a>
          <Popover
            overlayClassName="lcsc-popover-wrapper"
            overlayStyle={{
              width: '199px',
              height: '129px',
            }}
            overlayInnerStyle={{
              padding: '20px',
            }}
            content={<ServiceCenterPop headBuriedPoint={headBuriedPoint} />}
          >
            <span className="hover:text-lcBlue flex cursor-pointer items-center">
              <span>联系客服</span>
              <SvgIcon app="common" iconName="down-outlined" className="ml-[6px] h-[8px] w-[8px]" />
            </span>
          </Popover>
          <a
            target="_blank"
            href={`${resourceData?.projectConfigVO?.lcscWwwUrl}/help/101.html`}
            className="hover:text-lcBlue"
            rel="nofollow"
            onClick={() => headBuriedPoint('new_help', `${resourceData?.projectConfigVO?.lcscWwwUrl}/help/101.html`)}
            data-spm="bz"
          >
            <span>帮助中心</span>
          </a>
          <Popover content={<MerchantServicePop resourceData={resourceData} />}>
            <span className="hover:text-lcBlue flex cursor-pointer items-center">
              <span>供应商合作</span>
              <SvgIcon app="common" iconName="down-outlined" className="ml-[6px] h-[8px] w-[8px]" />
            </span>
          </Popover>
          <Popover
            overlayClassName="lcsc-popover-wrapper min-w-[1088px]"
            placement="bottomRight"
            overlayInnerStyle={{ padding: '24px 32px 48px' }}
            content={<GroupSitesPop />}
          >
            <span className="hover:text-lcBlue flex cursor-pointer items-center">
              <span>嘉立创产业服务群</span>
              <SvgIcon app="common" iconName="down-outlined" className="ml-[6px] h-[8px] w-[8px]" />
            </span>
          </Popover>
        </div>
      </div>
    </section>
  );
}

function SearchInput({
  isFloat,
  className,
  headerAd,
  isLg,
  notIndexHeaderAdapter,
  searchKeyWord,
  changeSearchKeyWord,
}) {
  const { isMro, resourceData, onlySScreen } = useContext(LayoutContext);

  const iptRef = useRef();
  const jumpToSoRef = useRef(null);
  useEffect(() => {
    if (iptRef.current && (location?.pathname === '/index' || location?.pathname === '/')) {
      // 只有首页才需要自动聚焦
      iptRef.current.focus();
    }
  }, []);

  /**搜索框相关逻辑 */
  const [searchType, setSearchType] = useState('all');
  const dropdownOptions = [
    {
      key: 'all',
      label: '全部商品',
      onClick: () => {
        handleSearchTypeChange('all');
      },
    },
    {
      key: 'self_operated',
      label: '电子元器件',
      onClick: () => {
        handleSearchTypeChange('self_operated');
      },
    },
    {
      key: 'MRO',
      label: '工业品',
      onClick: () => {
        handleSearchTypeChange('MRO');
      },
    },
  ];

  const [searchBoxDarkGrainedWord, setSearchBoxDarkGrainedWord] = useState(headerAd?.searchBoxDarkGrainedWord);
  const [searchListStatus, setSearchListStatus] = useState(false);
  const [searchList, setSearchList] = useState([]); // 搜索记录
  const [searchListData, setSearchListData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const recommendDropWordList = headerAd?.searchBoxDropdownKeywords || [];

  useEffect(() => {
    const option = Utils.getUrlParam('searchSource') || '';
    Object.keys(searchSourceMap).forEach((key) => {
      if (searchSourceMap[key] === option) {
        handleSearchTypeChange(key);
      }
    });
    getSearchHistoryFormCookie();
  }, []);

  async function handleSearchTypeChange(value) {
    setSearchType(value);
    setIsOpen(false);
    if (value === 'MRO') {
      try {
        const res = await getMroResourceList();
        setSearchBoxDarkGrainedWord(res?.result?.commonConfigVO?.hotKeySearch);
      } catch (error) {
        console.error('获取MRO底纹词失败');
      }
    } else {
      setSearchBoxDarkGrainedWord(headerAd?.searchBoxDarkGrainedWord);
    }
  }

  function getSearchHistoryFormCookie() {
    const key = !isMro ? 'searchHistoryRecord' : 'mroSearchHistoryRecord';
    const searchHistoryRecord = Cookies.get(key) || '';
    const originHistory = searchHistoryRecord ? searchHistoryRecord.split('：') : [];
    const resList = [];
    originHistory.forEach((item, idx) => {
      if (isMro && idx < 5) {
        resList.push({
          word: item,
        });
      } else if (idx < 10) {
        resList.push({
          word: item,
        });
      }
    });
    setSearchList(resList);
  }

  const handleSearchInputKeyDown = (e) => {
    const { keyCode } = e;
    // 监听回车
    if (keyCode === 13) {
      handleGlobalSo({ clickedkeyWord: searchKeyWord });
    }
  };

  const handleSearchInputClick = () => {
    if (searchType === 'MRO') {
      return;
    }
    if (searchKeyWord) {
      setSearchListStatus(true);
      return;
    }
    if (!searchList?.length && !recommendDropWordList?.length) {
      setSearchListStatus(false);
      return;
    }
    setSearchListStatus(true);
  };

  async function getAssociationalWordListFormAPI(searchKeyWord) {
    try {
      // 1、keyword缓存：obj[key]:[]
      // 2、防抖
      const { result } = await getAssociationalWordList({
        keyword: encodeURIComponent(searchKeyWord),
        catalogId: '',
        searchSource: 'main_so',
      });

      if (!result) {
        handleHideSearchList();
        setSearchListData([]);
      } else {
        const searchList = [];
        for (const i in result) {
          for (const j in result[i]) {
            const obj = {};
            obj.word = result[i][j];
            // 兼容版本
            if (typeof obj.word !== 'string') {
              continue;
            }
            obj.num = j;
            // 区分类型
            obj.type = i;
            // 1: "九九物联~brandId=11442~imgPath=/upload/public/brand/logo/20180125/1516847981635.jpg"
            if (obj.word.indexOf('~') !== -1) {
              obj.wordArr = [];
              (obj.word.split('~') || []).forEach((item) => {
                const wordObj = { itemValue: item };
                if (item.indexOf('=') !== -1) {
                  wordObj.itemKeyArr = item.split('=');
                }
                obj.wordArr.push(wordObj);
              });
            }
            searchList.push(obj);
            setSearchListData(searchList);
          }
        }
        searchResult(result);
      }
    } catch (error) {
      setSearchListData([]);
      handleHideSearchList();
    }
  }

  const handleToSearch = (value) => {
    if (value.trim() || value.trim() === '0') {
      getAssociationalWordListFormAPI(value);
    } else {
      handleSearchInputClick();
    }
  };

  const debouncedHandleSearchInputChange = useCallback(
    debounce((value) => handleToSearch(value), 300),
    [] // 空依赖数组确保防抖函数不会在每次渲染时重新创建
  );

  // 输入框的 onChange 事件处理器
  const handleChange = (e) => {
    const value = e.target.value;
    changeSearchKeyWord(value);
    if (searchType === 'MRO') {
      return;
    }
    debouncedHandleSearchInputChange(value); // 传递提取的值
  };

  // 清理防抖函数，防止内存泄漏
  useEffect(() => {
    return () => {
      debouncedHandleSearchInputChange.cancel();
    };
  }, [debouncedHandleSearchInputChange]);

  const handleHideSearchList = () => {
    setSearchListStatus(false);
    getSearchHistoryFormCookie();
  };

  const searchResult = (result) => {
    const arr = [];
    Object.keys(result).forEach((key) => {
      arr.push(...result[key]);
    });
    setSearchListStatus(arr.length > 0);
  };

  const handleGlobalSo = async ({ clickedkeyWord, keyWordIdx, type, tipType }) => {
    if (Utils.isXss(clickedkeyWord)) {
      message.warning('搜索词内含有非法语句，请修改搜索词');
      return;
    }
    // ⚠ 危险重重的逻辑
    const searchSource = Utils.getUrlParam('searchSource') || 'main_so';
    const isMroFlag = isMro || searchSource === 'MRO';
    let hotKey = Utils.replaceSpecialChar(searchBoxDarkGrainedWord);
    let keyword = Utils.replaceSpecialChar(clickedkeyWord);
    let soBuriedPointData = '';
    // ⚠
    const option = isMroFlag ? 'MRO' : searchType;
    sessionStorage.setItem('main-site-search-option', option);
    // ⚠
    let hintSearch = false; // 底纹词搜索
    if (keyword == '请输入型号或者产品相关信息...') {
      keyword = '';
    }
    if (hotKey == '请输入型号或者产品相关信息...') {
      hotKey = '';
    }
    if (hotKey && !keyword) {
      keyword = hotKey;
      hintSearch = true;
    }
    if (keyword) {
      changeSearchKeyWord(keyword);
      if (resourceData?.commonConfigVO?.globalSearchNeedLogin === true) {
        window.location.href = '/login.html';
      } else {
        // 用户行为分析埋点
        if (!['history', 'suggestion'].includes(type)) {
          const data = { kw: keyword };
          if (hintSearch) {
            data.type = 'hint';
            data.option = option;
          }
          soBuriedPointData = JSON.stringify({
            ty: 'click',
            op: 'search',
            cp: getBuriedPointCP(),
            data,
          });
        } else {
          const data = { kw: keyword, ix: keyWordIdx, type, option };
          if (tipType) {
            data['tip_type'] = tipType;
          }
          soBuriedPointData = JSON.stringify({
            ty: 'click',
            op: 'search_tip',
            cp: getBuriedPointCP(),
            data,
          });
        }

        // mro暗纹词
        if (isMroFlag && keyword === hotKey) {
          soBuriedPointData = JSON.stringify({
            ty: 'click',
            op: 'shade',
            cp: 'mro_search_box',
            data: { kw: keyword },
          });
        }
        let targetUrl =
          resourceData?.projectConfigVO?.lcscSearchUrl + (option === 'MRO' ? '/mro/global.html' : '/global.html');
        if (searchSource === 'mro_so') {
          targetUrl = resourceData?.projectConfigVO?.lcscSearchUrl + '/global.html';
        }

        const soUrl = option === 'MRO' ? '/mroso/check/global' : '/check/global';
        let formData = '';
        try {
          const res = await checkKeyWord(`${soUrl}?words=${Utils.safeEncodeURI(keyword)}`);
          if (res.code === 200) {
            if (res.result && res.result.keywordJumpUrl) {
              // 执行新开页面跳转
              let finalUrl = res.result.keywordJumpUrl;
              if (jumpToSoRef?.current) {
                finalUrl = Utils.getBtnSpmQueryUrl(res.result.keywordJumpUrl, jumpToSoRef?.current);
              }
              const win = window.open(finalUrl);
              win.opener = null;
              return;
            } else {
              // ⚠
              // $('#global-current-catalog').val($('.sch-bd .sch-bd01').attr('data-id'));
              // ⚠
              formData = `?k=${Utils.safeEncodeURI(keyword, 1)}`;
              if (hotKey) {
                formData += `&hot-key=${Utils.safeEncodeURI(hotKey, 1)}`;
              }
              if (isMro) {
                formData += `&searchSource=mro_so`;
              } else if (searchSourceMap[option]) {
                formData += `&searchSource=${searchSourceMap[option]}`;
              }
            }
          }
        } catch (error) {
          formData = `?k=${Utils.safeEncodeURI(keyword, 1)}`;
          if (hotKey) {
            formData += `&hot-key=${Utils.safeEncodeURI(hotKey, 1)}`;
          }
          const searchSourceMap = {
            all: '',
            self_operated: 'main_eci',
            MRO: 'main_mro',
          };
          if (isMro) {
            formData += `&searchSource=mro_so`;
          } else if (searchSourceMap[option]) {
            formData += `&searchSource=${searchSourceMap[option]}`;
          }
        }
        // 将keyword写入cookie中
        const key = !isMroFlag ? 'searchHistoryRecord' : 'mroSearchHistoryRecord';
        const searchHistoryRecord = Cookies.get(key) || '';
        const searchHistoryRecordArr = searchHistoryRecord ? searchHistoryRecord.split('：') : [];
        const searchHistoryRecordArr2 = [];
        searchHistoryRecordArr.forEach((item) => {
          if (item != keyword) {
            searchHistoryRecordArr2.push(item);
          }
        });
        searchHistoryRecordArr2.unshift(keyword.substring(0, 50));
        // 展示客户最近3条搜索历史
        if (isMroFlag) {
          if (searchHistoryRecordArr2.length > 5) {
            searchHistoryRecordArr2.length = 5;
          }
        } else {
          if (searchHistoryRecordArr2.length > 10) {
            searchHistoryRecordArr2.length = 10;
          }
        }
        Cookies.set(key, searchHistoryRecordArr2 ? searchHistoryRecordArr2.join('：') : '', {
          domain: '.szlcsc.com',
          expires: 30,
          path: '/',
        });
        Cookies.set('soBuriedPointData', soBuriedPointData, {
          domain: '.szlcsc.com',
          expires: 30,
          path: '/',
        });
        if (formData) {
          let finalUrl = targetUrl + formData;
          if (jumpToSoRef?.current) {
            finalUrl = Utils.getBtnSpmQueryUrl(targetUrl + formData, jumpToSoRef?.current);
          }
          location.href = finalUrl;
        }
      }
    }
  };

  return (
    <div className="relative">
      <div id="header-search-bar" className="ml-[30px]">
        <Popover
          overlayClassName="lcsc-popover-wrapper-hide-top-arrow"
          placement="bottom"
          onOpenChange={(e) => {
            if (!e) {
              setSearchListStatus(false);
            }
          }}
          content={
            searchKeyWord && searchListData.length ? (
              <SearchListPop
                searchKeyWord={searchKeyWord}
                hidePop={handleHideSearchList}
                handleClickKeyWord={handleGlobalSo}
                searchList={searchListData}
              />
            ) : (
              <SearchHistoryListPop
                searchList={searchList}
                recommendDropWordList={recommendDropWordList}
                hidePop={handleHideSearchList}
                handleClickKeyWord={handleGlobalSo}
              />
            )
          }
          open={searchListStatus}
          showArrow={false}
          overlayInnerStyle={{
            padding: searchKeyWord && searchListData.length ? '20px 0 10px 0' : '20px 20px 10px 20px',
          }}
          overlayStyle={{
            width: isFloat ? '697px' : notIndexHeaderAdapter ? (isLg ? '614px' : '460px') : isLg ? '593px' : '460px',
          }}
          getPopupContainer={() => (isFloat ? document.getElementById('header-search-bar') : document.body)}
        >
          <div
            className={`flex w-[460px] items-center ${isFloat ? 'w-[697px]' : notIndexHeaderAdapter ? Utils.addBigScreenClassName('', '_lg:w-[614px]', onlySScreen) : Utils.addBigScreenClassName('', '_lg:w-[593px]', onlySScreen)}  border-lcBlue relative box-border h-[42px] overflow-hidden rounded-[10px] border-2 border-solid bg-white`}
          >
            {isMro ? (
              <></>
            ) : (
              <Dropdown
                menu={{
                  items: dropdownOptions,
                }}
                onOpenChange={(e) => {
                  setIsOpen(e);
                }}
                placement="bottomLeft"
                trigger="hover"
              >
                <div className="flex h-[40px] items-center">
                  <div
                    className="boredr-r-[#DBE0E9] box-border flex h-[14px] w-[118px] cursor-pointer items-center justify-between border-r-[1px] px-[10px]
                        text-[14px]"
                  >
                    <span>{dropdownOptions.find((t) => t.key === searchType)?.label}</span>
                    <SvgIcon
                      app="common"
                      iconName="down-outlined"
                      className={`transform-all ml-[6px] w-[12px] text-[#6c6c6c] duration-300 ${isOpen ? 'rotate-[180deg]' : ''}`}
                    />
                  </div>
                </div>
              </Dropdown>
            )}
            <input
              ref={iptRef}
              type="text"
              id="global-seach-input"
              placeholder={searchBoxDarkGrainedWord || '请输入型号或者产品相关信息...'}
              className="h-full flex-1 pl-[10px] text-[14px] focus:border-[#199FE9] focus:outline-none focus:ring-0"
              value={searchKeyWord}
              onChange={handleChange}
              onClick={handleSearchInputClick}
              onKeyDown={handleSearchInputKeyDown}
              autoComplete="off"
              maxLength={52}
            />
            <button
              id="search"
              className="bg-lcBlue border-lcBlue h-full w-[73px] border-[2px] text-[16px] text-white"
              onClick={(e) => {
                handleGlobalSo({ clickedkeyWord: searchKeyWord }, e);
              }}
              data-spm="ss"
              ref={jumpToSoRef}
            >
              搜索
            </button>
          </div>
        </Popover>
      </div>
      <KeyWords
        searchType={searchType}
        handleGlobalSo={handleGlobalSo}
        className={className}
        isFloat={isFloat}
        headerAd={headerAd}
      />
    </div>
  );
}

function KeyWords({ headerAd, isFloat, className, handleGlobalSo, searchType }) {
  const belowTheSearchBoxKeywords = headerAd?.belowTheSearchBoxKeywords || [];

  function hotKeyBuriedPoint(kw) {
    buriedPoint({
      pf: 'pc',
      ty: 'click',
      op: 'hot',
      data: { cp: 'hot', op: 'search', kw, option: searchType },
    });
  }
  if (!belowTheSearchBoxKeywords || isFloat) {
    return <></>;
  }
  return (
    <ul className={`absolute left-0 top-[52px] ml-[30px] flex w-[140%] text-[12px] ${className || ''}`} data-spm="hk">
      {belowTheSearchBoxKeywords.map((wordObj, idx) => {
        const linkStyle = {
          color: wordObj.colour,
          // fontWeight: wordObj.needBold === 'yes' ? 'bold' : 'normal',
        };
        return (
          <li className="mr-[12px]" key={idx} onClick={() => hotKeyBuriedPoint(wordObj.keyword)}>
            {wordObj?.targetLink ? (
              <a
                style={linkStyle}
                href={wordObj?.targetLink}
                title={wordObj.title}
                target="_blank"
                rel={wordObj.rel ? 'nofollow' : ''}
                data-spm={idx + 1}
              >
                {wordObj.keyword}
              </a>
            ) : (
              <button
                onClick={(e) => handleGlobalSo({ clickedkeyWord: wordObj.keyword }, e)}
                style={linkStyle}
                title={wordObj.tile}
                data-spm={idx + 1}
              >
                {wordObj.keyword}
              </button>
            )}
          </li>
        );
      })}
    </ul>
  );
}

const searchSourceMap = {
  all: '',
  self_operated: 'main_eci',
  MRO: 'main_mro',
};

export function SearchBar({
  className,
  isFloat,
  wrapClassName,
  headerAd,
  isLg,
  notIndexHeaderAdapter,
  searchKeyWord,
  changeSearchKeyWord,
  showH1Title = false, // 是否使用h1标题
}) {
  const { isMro, resourceData, onlySScreen } = useContext(LayoutContext);
  const { userInfo } = useUserStore();
  const showCartIcon = (!isFloat && notIndexHeaderAdapter) || (!notIndexHeaderAdapter && isLg);

  let searchWrapclassNames = isFloat
    ? 'flex w-full justify-center items-center w-full py-[15px] shadow-[0_2px_4px_0px_rgba(149,156,176,0.21)]'
    : `flex w-[1200px] pt-[20px] ${notIndexHeaderAdapter ? 'm-auto' : 'justify-center'}`;

  if (!isFloat) {
    searchWrapclassNames = Utils.addBigScreenClassName(searchWrapclassNames, '_lg:w-[1552px]', onlySScreen);
  }

  const rendContent = () => {
    return (
      <>
        {isMro ? (
          <a data-spm="lg" href={resourceData?.projectConfigVO?.lcscMroUrl} className="flex items-center">
            <Image
              className="cursor-pointer"
              width={218}
              height={57}
              src="https://static.szlcsc.com/ecp/assets/web/common/images/mro/logo.svg"
              alt={'立创MRO——产线工业品一站式采购'}
              preview={false}
            />
            <span className="ml-[14px] block w-[80px] text-[16px] leading-[20px] text-[#000]">
              产线工业品一站式采购
            </span>
          </a>
        ) : (
          <a
            data-spm="lg"
            href={headerAd?.logo?.targetLink || resourceData?.projectConfigVO?.lcscWwwUrl}
            onClick={() =>
              headBuriedPoint('logo', headerAd?.logo?.targetLink || resourceData?.projectConfigVO?.lcscWwwUrl)
            }
          >
            {isFloat ? (
              <Image
                className="cursor-pointer"
                width={132}
                height={36}
                src={'//static.szlcsc.com/ecp/assets/web/common/images/241120s-logo.svg'}
                alt={headerAd?.logo?.title || '立创商城logo'}
                preview={false}
              />
            ) : (
              <Image
                className="cursor-pointer"
                width={409}
                height={57}
                src={headerAd?.logo?.logo || 'https://static.szlcsc.com/ecp/assets/newWeb/header/main_logo.svg'}
                alt={headerAd?.logo?.title || '立创商城logo'}
                preview={false}
              />
            )}
          </a>
        )}
      </>
    );
  };

  // 首页使用h1标签,其他都用div
  const parentRenderContent = () => {
    if (showH1Title) {
      return (
        <h1 aria-label="立创商城一站式电子元器件采购商城" className={`${isFloat ? 'h-[36px]' : 'h-[57px]'}`}>
          {rendContent()}
        </h1>
      );
    } else {
      return (
        <div aria-label="立创商城一站式电子元器件采购商城" className={`${isFloat ? 'h-[36px]' : 'h-[57px]'}`}>
          {rendContent()}
        </div>
      );
    }
  };

  /**搜索框相关逻辑 end */
  return (
    <section className={`w-full bg-[white] ${wrapClassName}`} data-spm="hd">
      <div className={searchWrapclassNames}>
        {parentRenderContent()}
        <div className="flex items-start">
          <SearchInput
            isFloat={isFloat}
            headerAd={headerAd}
            isLg={isLg}
            className={className}
            notIndexHeaderAdapter={notIndexHeaderAdapter}
            searchKeyWord={searchKeyWord}
            changeSearchKeyWord={changeSearchKeyWord}
          />
          {isMro ? (
            <a
              data-spm="xj"
              className="relative ml-[20px] flex h-[42px] w-[112px] items-center justify-center rounded-[10px] bg-[#fff4f3] text-[14px] text-[#f74747]"
              rel="nofollow"
              href={`${resourceData?.projectConfigVO?.lcscMroUrl}/mro/quick-inquiry.html`}
              target="_blank"
            >
              <SvgIcon app="common" iconName="xj" className="h-[21px] w-[14px]" />
              <span className="ml-[7px]">快速询价</span>
            </a>
          ) : (
            <BomUpload
              resourceData={resourceData}
              headBuriedPoint={headBuriedPoint}
              isLg={isLg}
              notIndexHeaderAdapter={notIndexHeaderAdapter}
              onlySScreen={onlySScreen}
              isFloat={isFloat}
            ></BomUpload>
          )}
          <Popover
            overlayClassName="lcsc-popover-wrapper"
            placement="bottomRight"
            overlayInnerStyle={{ padding: '10px', maxHeight: '370px' }}
            overlayStyle={{
              width: '599px',
              height: '380px',
              paddingTop: '8px',
            }}
            destroyTooltipOnHide={true}
            content={<ShopCarPop />}
            getPopupContainer={() => (isFloat ? document.getElementById('float-header') : document.body)}
          >
            <a
              data-spm="c2"
              target="_blank"
              href={`${resourceData?.projectConfigVO?.lcscCartUrl}/cart/display.html`}
              rel="nofollow"
              id="cart"
              className={`text-lcBlue relative flex h-[42px] ${isFloat ? 'ml-[30px] w-[103px]' : notIndexHeaderAdapter ? Utils.addBigScreenClassName('ml-[18px] w-[112px]', '_lg:w-[140px] _lg:ml-[30px]', onlySScreen) : Utils.addBigScreenClassName('ml-[20px] w-[93px]', '_lg:w-[112px]', onlySScreen)} items-center justify-center rounded-[10px] border-[1px] border-solid border-[#EDF9FF] bg-[#EDF9FF] 
                text-[14px] hover:border-[#199FE9]`}
              onClick={() =>
                headBuriedPoint('cart_icon', `${resourceData?.projectConfigVO?.lcscCartUrl}/cart/display.html`)
              }
            >
              {showCartIcon && <SvgIcon app="common" iconName="cart_t_new" className="h-[18px] w-[19px]" />}
              <span className="ml-[7px]">购物车</span>
              <span
                id="cart-num"
                className="absolute right-0 top-0 ml-[1px] flex h-[14px] items-center justify-center self-start rounded-[8px] rounded-bl-none bg-[#ff4960] px-[4px] text-[12px] text-white"
              >
                {userInfo?.cartNum > 99 ? '99+' : userInfo?.cartNum || '0'}
              </span>
            </a>
          </Popover>
        </div>
      </div>
    </section>
  );
}

export function MenuBar({ headerAd }) {
  const websiteNavList = headerAd?.navigationBars || [];
  const xsIconClassName = 'size-[16px] bg-no-repeat mr-[4px]';
  const mdIconClassName = 'w-[28px] h-[16px] bg-no-repeat mr-[4px]';
  const lgIconClassName = 'w-[40px] h-[16px] bg-no-repeat mr-[4px]';

  function getIndexWebsiteNavsDom(navList) {
    if (!navList || !Array.isArray(navList)) {
      return [];
    }
    return navList.map((websiteNav, idx) => {
      const navLinkClassName =
        'hover:text-lcBlue flex items-center h-[24px] leading-[24px] mr-[30px] last-of-type:mr-0';
      return (
        <a
          key={idx}
          className={navLinkClassName}
          href={websiteNav?.targetLink}
          target="_blank"
          onClick={() => {
            getNavPoint(websiteNav.navigationWords, websiteNav?.targetLink);
          }}
          data-spm={idx + 1}
        >
          {websiteNav.cornerMark === 'hot' && <SvgIcon app="common" iconName="hot" className={xsIconClassName} />}
          {websiteNav.cornerMark === 'new' && <SvgIcon app="common" iconName="new" className={xsIconClassName} />}
          {websiteNav.cornerMark === 'supplier' && <SvgIcon app="common" iconName="gys" className={lgIconClassName} />}
          {websiteNav.cornerMark === 'enter' && <SvgIcon app="common" iconName="enter" className={mdIconClassName} />}
          {websiteNav.cornerMark === '9.9' && (
            <span
              className={`${mdIconClassName} bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/www/home/navBar/by.gif)]`}
            ></span>
          )}
          {websiteNav.cornerMarkUrl && <img className="mr-[4px] inline-block" src={websiteNav.cornerMarkUrl} alt="" />}
          <span className="text-[16px]">{websiteNav.navigationWords}</span>
        </a>
      );
    });
  }

  const websiteNavListDom = getIndexWebsiteNavsDom(websiteNavList);
  return (
    <nav
      className="mt-[30px] flex items-center justify-center text-[16px] font-bold text-[#000]"
      data-spm="nav"
      role="navigation"
      aria-label="主站菜单导航"
    >
      {websiteNavListDom}
    </nav>
  );
}

// 非首页的MenuBar
export function NotIndexMenuBar({ className = '', headerAd }) {
  const { resourceData, isMro, onlySScreen, showSeoCatalog } = useContext(LayoutContext);
  const websiteNavList = headerAd?.navigationBars || [];
  const xsIconClassName = 'size-[16px] bg-no-repeat mr-[4px]';
  const mdIconClassName = 'w-[28px] h-[16px] bg-no-repeat mr-[4px]';
  const lgIconClassName = 'w-[40px] h-[16px] bg-no-repeat mr-[4px]';
  let menuBarClassNam = `bg-white m-auto mt-[27px] h-[52px] flex w-[1200px] items-center text-[16px] ${className} overflow-hidden`;
  menuBarClassNam = Utils.addBigScreenClassName(menuBarClassNam, '_lg:w-[1552px]', onlySScreen);

  const catalogBtnRef = useRef(null);
  const [websiteNavListMap, setWebsiteNavListMap] = useState({});

  useEffect(() => {
    const websiteNavListMapState = {};
    websiteNavList.some((item) => {
      const pathname = location?.pathname.includes('sea_patrol_project') ? 'sea_patrol' : location?.pathname;
      if (item.targetLink && item.targetLink.includes(pathname) && pathname !== '/') {
        websiteNavListMapState[item?.navigationWords] = 'text-lcBlue';
        return true;
      } else {
        websiteNavListMapState[item?.navigationWords] = '';
        return false;
      }
    });
    setWebsiteNavListMap(websiteNavListMapState);
  }, []);

  function getWebsiteNavsDom(navList) {
    if (!navList || !Array.isArray(navList)) {
      return [];
    }
    return navList.map((websiteNav, idx) => {
      const navLinkClassName = `mr-[24px] flex items-center hover:text-lcBlue last:mr-0 ${websiteNavListMap[websiteNav?.navigationWords] || ''}`;
      return (
        <a
          key={idx}
          className={navLinkClassName}
          href={websiteNav?.targetLink}
          target="_blank"
          onClick={() => {
            getNavPoint(websiteNav.navigationWords, websiteNav?.targetLink);
          }}
          data-spm={idx + 1}
        >
          {websiteNav.cornerMark === 'hot' && <SvgIcon app="common" iconName="hot" className={xsIconClassName} />}
          {websiteNav.cornerMark === 'new' && <SvgIcon app="common" iconName="new" className={xsIconClassName} />}
          {websiteNav.cornerMark === 'supplier' && <SvgIcon app="common" iconName="gys" className={lgIconClassName} />}
          {websiteNav.cornerMark === 'enter' && <SvgIcon app="common" iconName="enter" className={mdIconClassName} />}
          {websiteNav.cornerMark === '9.9' && (
            <span
              className={`${mdIconClassName} bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/www/home/navBar/by.gif)]`}
            ></span>
          )}
          {websiteNav.cornerMarkUrl && <img className="mr-[4px] inline-block" src={websiteNav.cornerMarkUrl} alt="" />}
          <span className="text-[16px]">{websiteNav.navigationWords}</span>
        </a>
      );
    });
  }

  const firstNav = getWebsiteNavsDom(websiteNavList);

  return (
    <section className={menuBarClassNam}>
      {showSeoCatalog && <SeoCatalogsContent onlySScreen={onlySScreen} resourceData={resourceData} />}
      <Popover
        overlayInnerStyle={{
          position: 'relative',
          padding: '20px 0 20px 20px',
          width: '242px',
        }}
        overlayClassName="lcsc-popover-wrapper-hide-top-arrow"
        zIndex={90}
        placement="bottomLeft"
        showArrow={false}
        content={
          !isMro ? (
            <CatalogsPop onlySScreen={onlySScreen} resourceData={resourceData} />
          ) : (
            <MroCatalogsPop></MroCatalogsPop>
          )
        }
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      >
        <button
          ref={catalogBtnRef}
          className={`flex h-full w-[136px] items-center justify-center rounded-t-[4px] bg-[#008DDB] font-bold text-[#ffff]`}
        >
          <SvgIcon app="common" iconName="all-product" className="h-[16px] w-[16px]" />
          <span className="ml-[8px]">商品分类</span>
        </button>
      </Popover>

      <section
        className={Utils.addBigScreenClassName(
          'flex w-[1064px] items-center pl-[37px] font-bold text-[#000]',
          '_lg:w-[1416px]',
          onlySScreen
        )}
        style={{
          wordBreak: 'keep-all',
        }}
        data-spm="nav"
      >
        {firstNav}
      </section>
    </section>
  );
}

export function MainArea({
  className,
  headerAd,
  notIndexHeaderAdapter,
  isLgScreen,
  searchKeyWord,
  changeSearchKeyWord,
}) {
  return (
    <section className={`border-b-[2px] border-[#0093E6] bg-[#FFFFFF] text-[#56657F]`}>
      <SearchBar
        className={className}
        isFloat={false}
        headerAd={headerAd}
        isLg={isLgScreen}
        notIndexHeaderAdapter={notIndexHeaderAdapter}
        searchKeyWord={searchKeyWord}
        changeSearchKeyWord={changeSearchKeyWord}
      />
      {notIndexHeaderAdapter ? (
        <NotIndexMenuBar
          className={className}
          headerAd={headerAd}
          isLg={isLgScreen}
          notIndexHeaderAdapter={notIndexHeaderAdapter}
        ></NotIndexMenuBar>
      ) : (
        <MenuBar className={className} />
      )}
    </section>
  );
}

export default function BaseHeader(props) {
  const { headerAd, notIndexHeaderAdapter, isLgScreen, pageAutoRefreshLoginInfo, isNeedTopAd } = props;
  const { globalSearchKeyword } = useContext(LayoutContext);
  const [searchKeyWord, setSearchKeyWord] = useState(globalSearchKeyword);

  const [isFloat, setIsFloat] = useState(false);
  const debounceScroll = debounce(scrollFn, 40);
  const { updateUserInfo } = useUserStore();

  useEffect(() => {
    document.addEventListener('scroll', debounceScroll);
    Utils.reloadLoginFrame()
      .then((result) => {
        Utils.setInfoSecurityLocalStorage(result);
        pageAutoRefreshLoginInfo ? pageAutoRefreshLoginInfo(result) : autoRefreshLoginInfo(result);
      })
      .catch(() => {
        Utils.casLogin();
        getCartData();
      });
    return () => {
      document.removeEventListener('scroll', debounceScroll);
    };
  }, []);

  async function getCartData() {
    // 获取购物车
    const cartRes = await getCartDataApi();
    let cartNum = 0;
    if (cartRes.code !== 200 || !cartRes.result.shoppingCartVO.cartTotalSize) {
      cartNum = 0;
    } else {
      cartNum = cartRes.result?.shoppingCartVO?.cartTotalSize; // 购物车数量
    }
    updateUserInfo({
      complaintName: '',
      complaintPhone: '',
      couponNum: null,
      customerCode: '',
      customerLogin: 0,
      customerStarLevel: null,
      encryptSwitch: '',
      messageNum: null,
      privateKey: '',
      publicKey: '',
      saleQQ: null,
      salesmanCode: '',
      salesmanName: '',
      salesmanPhone: '',
      isUserLogin: null,
      isSettleAccount: null,
      isShowAgentPayOrderList: null,
      needChooseCusType: null,
      existSendOrder: null,
      cartNum, // 购物车数量
    });
  }

  function scrollFn() {
    let scrollTop = 0;
    if (document?.documentElement?.scrollTop) {
      scrollTop = document.documentElement.scrollTop;
    } else if (document?.body?.scrollTop) {
      scrollTop = document.body.scrollTop;
    }
    if (scrollTop > 135) {
      setIsFloat(true);
    } else {
      setIsFloat(false);
    }
  }

  // 自动刷新登录状态
  function autoRefreshLoginInfo(data) {
    updateUserInfo(data);
    const { customerCode } = data;
    // 用户行为分析埋点
    if (Cookies.get('isLoginCustomerFlag') !== customerCode) {
      Cookies.set('isLoginCustomerFlag', customerCode, {
        domain: '.szlcsc.com',
        path: '/',
      });

      buriedPoint({ ty: 'login', data: Cookies.get('noLoginCustomerFlag') });

      Cookies.set('noLoginCustomerFlag', '', {
        domain: '.szlcsc.com',
        path: '/',
      });
    }
  }

  const transitionClass = 'transition-all duration-500';

  const changeSearchKeyWord = (value) => {
    setSearchKeyWord(value);
  };

  return (
    <>
      <header
        className={`fixed z-[200] h-[72px] w-full transition-all duration-300 ${isFloat ? 'top-[0]' : 'top-[-99px]'}`}
        id={isFloat && notIndexHeaderAdapter ? 'float-header' : ''}
      >
        {isFloat && (
          <SearchBar
            className={transitionClass}
            isFloat
            headerAd={headerAd}
            isLg={isLgScreen}
            notIndexHeaderAdapter={notIndexHeaderAdapter}
            searchKeyWord={searchKeyWord}
            changeSearchKeyWord={changeSearchKeyWord}
          />
        )}
      </header>
      <header className="w-full">
        <Topbar className={transitionClass}></Topbar>
        {/* 广告位 */}
        {isNeedTopAd && <IndexTopBanner isNeedTopAd={isNeedTopAd}></IndexTopBanner>}
        <MainArea
          className={transitionClass}
          headerAd={headerAd}
          isLgScreen={isLgScreen}
          notIndexHeaderAdapter={notIndexHeaderAdapter}
          searchKeyWord={searchKeyWord}
          changeSearchKeyWord={changeSearchKeyWord}
        ></MainArea>
      </header>
    </>
  );
}
